import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo'
import { Wrapper } from './styled'

interface IProps {
  value: string
}

export const AnswerExplanation = ({ value }: IProps) => {
  const { t } = useTranslation()
  const translationPrefix = 'lessons.contentBlocks.evaluation'

  return (
    <Wrapper>
      <FontAwesomeIcon icon={faCircleInfo} />
      <div>
        <div>{t(`${translationPrefix}.answerExplanation`)}</div>
        <div>{value}</div>
      </div>
    </Wrapper>
  )
}

export default AnswerExplanation
